import { Tune } from "@mui/icons-material";
import { FC, useRef } from "react";
import UserMenuItem from "./UserMenuItem";
import { DialogHandle } from "../Dialog/DialogTypes";
import CommunicationPreferencesDialog from "./CommunicationPreferencesDialog";

const CommunicationPreferencesItem: FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const preferencesDialog = useRef<DialogHandle>(null);
  function showPreferences() {
    preferencesDialog.current?.show();
  }

  return (
    <>
      <UserMenuItem Icon={Tune} onClick={showPreferences}>
        Communication Preferences
      </UserMenuItem>
      <CommunicationPreferencesDialog
        ref={preferencesDialog}
        onClose={onClose}
      />
    </>
  );
};

export default CommunicationPreferencesItem;
